/**
 * PAY-1 (T149-082/083/084): the shared "a settings save did not actually
 * happen" contract, reused by every settings tab with a save handler
 * (payments, account, LINE, carriers, categories, expense categories,
 * customer sources) so the shape and the scroll-to-field behavior can't
 * drift between them.
 *
 * A save handler's `handleSave` returns `true` only when the save actually
 * happened; on `false` the caller shows success NEVER, and instead renders
 * `SettingsSaveAlert` (see `@/components/settings/SettingsSaveAlert`) from
 * this state.
 */
export interface SettingsSaveError {
  /** Set (and > 0) only on a client validation stop: how many fields failed. */
  fieldCount?: number
  /** Set only on a server failure (the save reached the API and it rejected). */
  serverMessage?: string
}

/**
 * Scrolls a field into view and focuses it; used right after a client
 * validation stop so the operator lands on the first field to fix. A no-op
 * when the id doesn't resolve to an element (nothing to focus, nothing to
 * crash on).
 */
export function scrollToAndFocusField(fieldId: string | undefined | null): void {
  if (!fieldId) return
  const el = document.getElementById(fieldId)
  if (!el) return
  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  if (el instanceof HTMLElement) el.focus({ preventScroll: true })
}
